import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LawnCareLanding from "./pages/LawnCareLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LawnCareLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;